import $ from "jquery"
import { each } from "lodash"
import ControlView from "views/control_view"

// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let SuperLightboxView

// Represents a lightbox which can be closed by clicking it.
export default SuperLightboxView = (function () {
  SuperLightboxView = class SuperLightboxView extends ControlView {
    static initClass() {
      this.prototype.className = "lightbox"
      this.prototype.tagName = "section"

      this.prototype.leaveWhenEscapePressed = true
      this.prototype.leaveWhenMaskClicked = true
      this.prototype.escapeKeyCode = 27
    }

    initialize(options) {
      this._handleMaskMouseDown = this._handleMaskMouseDown.bind(this)
      this._click = this._click.bind(this)
      this._keydown = this._keydown.bind(this)
      this._trapFocus = this._trapFocus.bind(this)
      if (options == null) {
        options = {}
      }
      this.bindings = []
      this.maskMouseDownStartedOnMask = false
      this._bindTo($(document), "keydown", this._keydown)
      this._bindTo($(document), "keydown", this._trapFocus)
      this.$el.on("mousedown", this._handleMaskMouseDown)
      this.$el.on("click", this._click)
      this.build()
      return super.initialize(options)
    }

    build() {
      this.$innerEl = $('<div class="lightbox-inner"></div>').appendTo(this.el)
      this.innerEl = this.$innerEl.get(0)
      return $("body").addClass("lightbox-open")
    }

    close() {
      this._unbindFromAll()
      this.off()
      this.remove()
      return $("body").removeClass("lightbox-open")
    }

    show(e) {
      super.show(e)

      // Focus the first focusable element after the lightbox is shown
      const focusableElement = this.$el
        .find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
        .first()

      if (focusableElement.length) {
        focusableElement.focus()
      }
    }

    _handleMaskMouseDown(event) {
      this.maskMouseDownStartedOnMask = $(event.target).is(".lightbox")
    }

    // Hide the lightbox if it is clicked.
    _click(event) {
      const $el = $(event.target)
      const href = $el.attr("href")
      if (href && href === "#") {
        event.preventDefault()
      }

      const shouldLeave =
        this.leaveWhenMaskClicked &&
        this.maskMouseDownStartedOnMask &&
        $el.is(".lightbox") &&
        this.isVisible()

      this.maskMouseDownStartedOnMask = false

      if (shouldLeave) {
        return this._leave()
      }
    }

    // Hide the lightbox if escape is pressed.
    _keydown(event) {
      if (this.leaveWhenEscapePressed && event.keyCode === this.escapeKeyCode && this.isVisible()) {
        event.preventDefault()
        return this._leave()
      }
    }

    _leave(e) {
      this.trigger("leave", this)
      if (e) {
        e.preventDefault()
      }
      return this.close()
    }

    _bindTo(source, event, callback) {
      source.bind(event, callback)
      return this.bindings.push({ source, event, callback })
    }

    _unbindFromAll() {
      each(this.bindings, (binding) => binding.source.unbind(binding.event, binding.callback))
      return (this.bindings = [])
    }

    // Don't let tab escape an opened lightbox
    _trapFocus(event) {
      const tabWasPressed = event.key === "Tab" || event.keyCode === 9
      if (!tabWasPressed || !this.isVisible()) return
      const focusableElements = this.$el.find(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      )
      const firstElement = focusableElements.first()[0]
      const lastElement = focusableElements.last()[0]
      const activeElement = document.activeElement

      // Only trap if focus is within the lightbox
      if (!this.$el[0]?.contains(activeElement)) return

      // Wrap around in either direction based on if shift is pressed or not
      if (event.shiftKey && activeElement === firstElement) {
        event.preventDefault()
        $(lastElement)?.focus()
      } else if (!event.shiftKey && activeElement === lastElement) {
        event.preventDefault()
        $(firstElement)?.focus()
      }
    }
  }
  SuperLightboxView.initClass()
  return SuperLightboxView
})()
